import { Document } from "src/core/types/document";

type DocumentMap = Record<string, Document>;

export type ExpirationUpdate = {
  fileId: string;
  expirationDate?: string | undefined;
};

type Options = {
  /** Permet de filtrer certains docCodes (ex: uniquement "kbis") */
  includeDocCode?: (docCode: string) => boolean;
};

/**
 * Détermine quels documents déjà uploadés (fileId) ont une expirationDate différente des valeurs par défaut.
 */
export const getDocumentsExpirationUpdates = (
  current: DocumentMap,
  defaults: DocumentMap,
  options?: Options
): ExpirationUpdate[] => {
  return Object.entries(current)
    .filter(([docCode, currentDoc]) => {
      if (options?.includeDocCode && !options.includeDocCode(docCode)) return false;

      // uniquement les docs déjà uploadés
      if (!currentDoc.fileId) {
        return false;
      }

      // Vérifier que l'expirationDate a changé
      const currentExpiration = currentDoc.expirationDate ?? undefined;
      const defaultExpiration = defaults[docCode]?.expirationDate ?? undefined;

      return currentExpiration !== defaultExpiration;
    })
    .map(([, doc]) => ({
      fileId: doc.fileId!,
      expirationDate: doc.expirationDate,
    }));
};
